module.exports = __webpack_public_path__ + "img/1.2b41afc2.jpeg";